import { RevenueService } from '../../shared/revenue.service';
import { CreditCardService } from '../../shared/credit-card/credit-card.service';
import { PaymentSourceService } from '../../shared/payment-source/payment-source.service';
import { PaymentTypeService } from '../../shared/payment-types/payment-type.service';
import { Component, Input, Output, EventEmitter, ViewEncapsulation, ViewChild } from '@angular/core';
import { NotificationService } from 'src/app/shared';
import { MultiInvoicePaymentComponent } from '../../multi-invoice-payment/multi-invoice-payment.component';

@Component({
  selector: 'wl-transactions-grid-apply-payments-dialog',
  templateUrl: './transactions-grid-apply-payments-dialog.component.html',
  styleUrls: ['./transactions-grid-apply-payments-dialog.component.less'],
  providers: [PaymentTypeService, PaymentSourceService, CreditCardService, RevenueService],
  encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TransactionsGridApplyPaymentsDialogComponent {
  @Output() showChange: EventEmitter<boolean> = new EventEmitter();
  @Input()
  get show() {
    return this._show;
  }
  set show(value: boolean) {
    this._show = value;
    this.showChange.emit(this._show);
  }
  @Input() invoiceNumbers: number[];
  @Input() profileId: number;
  @Output() paymentsApplied = new EventEmitter<any>();

  @ViewChild(MultiInvoicePaymentComponent) _multiInvoicePaymentComponent: MultiInvoicePaymentComponent;

  public loading: boolean;
  public isSaving: boolean;

  private _show: boolean;

  constructor(private _notificationService: NotificationService) {}

  applyClicked() {
    this.isSaving = true;
    this._multiInvoicePaymentComponent.applyPayments().then(
      (paymentsResult) => {
        this.isSaving = false;
        for (const message of paymentsResult.messages) {
          this._notificationService.success(message);
        }
        this.paymentsApplied.emit();
        this.show = false;
      },
      (paymentsResult) => {
        this.isSaving = false;
        for (const message of paymentsResult.messages) {
          this._notificationService.error(message);
        }
      }
    );
  }
}
